module.exports = __webpack_public_path__ + "img/data_storage.021f1df2.svg";